import { createSelector, createSlice } from "@reduxjs/toolkit";
import Provider from "provider";
import logging from "utils/logging";
import Analytics from "analytics";
import { EVENTS } from "analytics/events";
import { createOpenListenerAction, createCloseListenerAction } from "../../../redux/actions";
const log = logging.getLogger("Create Game Slice");

const createGameSlice = createSlice({
  name: "create",
  initialState: {
    creating: false,
    createdGameId: null,
    generation: null,
  },
  reducers: {
    creatingGame(state) {
      state.creating = true;
      state.createdGameId = null;
      state.generation = null;
    },
    gameCreated(state, action) {
      state.creating = false;
      state.createdGameId = action.payload.gameId;
    },
    generationUpdated(state, action) {
      state.generation = action.payload;
    },
    reset(state) {
      state.creating = false;
      state.createdGameId = null;
      state.generation = null;
    },
  },
});

const resetCreateGameStateAction = () => (dispatch) =>
  dispatch(createGameSlice.actions.reset());

const createGameAction = ({ gameName, roundCount, categoryCount, questionCount, description, managerId, useLorem=false }) => async (
  dispatch
) => {
  Analytics.track(EVENTS.GAME_CREATE_SUBMITTED, { creation_mode: "manual" });
  dispatch(createGameSlice.actions.creatingGame());
  const gameId = await Provider.createGame({ gameName, roundCount, categoryCount, questionCount, description, managerId, useLorem });
  log.debug("Got newly created game ID: ", gameId);
  dispatch(createGameSlice.actions.gameCreated({ gameId }));
};

const watchGameGenerationAction = (gameId) => (dispatch) => {
  dispatch(
    createOpenListenerAction(
      "createGame/watch_generation",
      "watch-generation"
    )({ gameId }, async () => {
      return Provider.watchGameGeneration(gameId, (generation) => {
        dispatch(createGameSlice.actions.generationUpdated(generation));
      });
    })
  );
};

const stopWatchingGameGenerationAction = (gameId) => (dispatch) => {
  dispatch(createCloseListenerAction("createGame/stop_watching_generation", "watch-generation")({ gameId }));
};

export { resetCreateGameStateAction, createGameAction, watchGameGenerationAction, stopWatchingGameGenerationAction };

// ------ Selectors -----
const selectCreateGameState = (state) => state.createGame;
const selectCreating = createSelector(
  selectCreateGameState,
  (state) => state.creating
);
const selectCreatedGameId = createSelector(
  selectCreateGameState,
  (state) => state.createdGameId
);
const selectGeneration = createSelector(
  selectCreateGameState,
  (state) => state.generation
);

export { selectCreating, selectCreatedGameId, selectGeneration };

export default createGameSlice.reducer;
